import { Globals } from '../../../../_globals';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { Component } from '@angular/core';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { ContactPerson } from '@dato-proxy/entities/contactperson.entity';

@Component({
    providers: ServiceBagServices,
    selector: 'app-contact-person-grid',
    templateUrl: './contact-person-grid.component.html',
    styleUrls: ['./contact-person-grid.component.scss']
})
export class ContactPersonGridComponent extends BaseGridComponent<ContactPerson, BaseState>
{
    Options = Globals.SystemOption;

    constructor(A: ServiceBagService) {
        super(A, 'ContactPersonGridComponent', ContactPerson, BaseState);
    }

    OnNavigate(e) {
        // condition is the same for editing and adding
        if (!this.ShowAddButton) return;

        this.Navigate(["/pages/contact-person", e.data.EntryID]);
    }

}
